import apiFetch from '../apiFetch'

export default function (serviceId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Service/${serviceId}/CompleteDeliveryPreparation`, method: 'PUT', body: null, token: token, lastAccessDate })
}
